module.exports = __webpack_public_path__ + "media/images/official/about_yamori_tsuwanoa-869e96fd1b58630446b2d76e4833d031.png";